module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "cancel-confirm",
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Our slots are limited and you may only reschedule once throughout your application and training process with HAWO. Please show up on time, and try to select times that will not conflict with other obligations.")]), _vm._v(" "), _c('p', [_vm._v("Your cancellations/reschedules will be taken into consideration when assessing your overall application results. Emergency cancellations will be reviewed on a case-by-case basis.")]), _vm._v(" "), _c('p', [_vm._v("A \"no show\" at any point in the process disqualifies you from completing the application process.")]), _vm._v(" "), (_vm.isRemark) ? _c('dl', {
    staticClass: "reason"
  }, [_c('dt', [_vm._v("Kindly specify your reason for " + _vm._s(_vm.typeText))]), _vm._v(" "), _c('dd', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "remark"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.remark = '';
        _vm.reject()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium",
      "disabled": _vm.isRemark && _vm.remark === ''
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.resolve({
          type: _vm.type,
          remark: _vm.remark
        });
        _vm.remark = '';
      }
    }
  }, [_vm._v("OK")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40414079"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/CancelConfirm.vue
// module id = 835
// module chunks = 1